// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2MtJr","inputDescription":"styles_inputDescription__11ptZ"};